import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const Definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            backgroundImage: anyImageOpResult,
            foregroundImage: anyImageOpResult,
            maskImage: anyImageOpResult,
            wrapAround: z._default(z.boolean(), false),
            testParam1: z.optional(z.number()),
            testParam2: z.optional(z.number()),
        }),
    },
}
